<template>
  <div class="card p-x2">
    <div class="f f-h f-ac f-sb">
      <div class="f f-h f-ac f-grow">
        <div class="f f-v f-gap-8 m-rx2">
          <cdn-svg
            :path="engagementBarsPath"
            :version="0"
            class="h-x4 w-x4"
          />
          <cdn-svg
            :path="sentimentFacePath"
            :version="0"
            class="h-x4 w-x4"
          />
        </div>

        <div class="f-v f-grow">
          <div class="t-lg bold">{{ formattedDateRange }}</div>
          <div class="t display m-tx1">{{ report.summary }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import useEngagementReportIcons from 'composables/team-pulse/icons';

const props = defineProps({
  report: {
    type: Object,
    required: true,
  },
});

const { engagementBarsPath, sentimentFacePath } = useEngagementReportIcons(
  computed(() => props.report),
);

const formattedDateRange = computed(() => {
  const start = new Date(props.report.startDate);
  const end = new Date(props.report.endDate);
  const formatter = new Intl.DateTimeFormat('en-US', { month: 'short', day: '2-digit' });
  return `${formatter.format(start)} - ${formatter.format(end)}`;
});
</script>
